import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Shield = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m9.5 11.75 1.5 1.5 3.5-3.5m5.5 2.162V7.177a2 2 0 0 0-1.35-1.891l-6-2.063a2 2 0 0 0-1.3 0l-6 2.063A2 2 0 0 0 4 7.177v4.735c0 4.973 4 7.088 8 9.246 4-2.158 8-4.273 8-9.246'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.975 2.278a3 3 0 0 0-1.95 0l-6 2.063A3 3 0 0 0 3 7.178v4.735c0 2.807 1.149 4.83 2.813 6.404 1.572 1.489 3.632 2.6 5.555 3.637l.157.084a1 1 0 0 0 .95 0l.157-.084c1.923-1.037 3.983-2.148 5.556-3.637C19.85 16.742 21 14.72 21 11.913V7.178a3 3 0 0 0-2.025-2.837zm2.055 8.002a.75.75 0 1 0-1.06-1.06L11 12.19l-.97-.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
